const chatGallery = {
    show: false,
    hasMore: true,
    isLoading: false,
    filter: 'purchased',
    messages: [],
    activeMessage: [],
    source: null,
};

export default chatGallery;
